import { gql } from '@apollo/client'
import contractChangeFragment from '../contract/fragments/contractChange.fragment'
import latestContractFragment from '../contract/fragments/latestContract.fragment'
import salaryOfYearFragment from '../contract/fragments/salaryOfYearFragment'
import targetBonusOfYearFragment from '../contract/fragments/targetBonusOfYear.fragment'
import contractValidityInYearFragment from '../contract/fragments/contractValidityInYear.fragment'
import meetingCoreFragment from '../meeting/fragments/meetingCore.fragment'
import meetingRestFragment from '../meeting/fragments/meetingRest.fragment'
import fullObjectiveFragment from '../objectives/ObjectiveDTO.fragment'

export const GET_MANAGER_MEETING_STEP_TARGETS = gql`
  query getManagerMeetingStepTargets(
    $employeeId: HashedId!
    $meetingId: HashedId!
    $year: Int!
    $country: Country!
    $withChanges: Boolean!
    $includeAllTargetBoni: Boolean!
  ) {
    objectivesInMeeting(meetingId: $meetingId) {
      ...fullObjectiveFragment
    }

    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...TargetBonusOfYear
    }
    contractChangesByEmployee(employeeId: $employeeId) @include(if: $withChanges) {
      ...ContractChange
    }
    currentContract(employeeId: $employeeId) @include(if: $withChanges) {
      ...LatestContractDTO
    }
    salaryOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...SalaryOfYear
    }
    contractsInYear(employeeId: $employeeId, year: $year) {
      ...ContractValidityInYear
    }
    branchOfficeByEmployee(employeeId: $employeeId) {
      code
      name
      timezone
      addressId
    }
    isBonusValidationEnabled(country: $country)
  }
  ${fullObjectiveFragment}
  ${targetBonusOfYearFragment}
  ${contractChangeFragment}
  ${latestContractFragment}
  ${salaryOfYearFragment}
  ${contractValidityInYearFragment}
`

export const EMPLOYEE_CONFIRM_PREPARATION = gql`
  mutation EmployeeConfirmPreparation($meetingId: HashedId!, $input: EmployeeConfirmPreparationInput!) {
    employeeConfirmPreparation(meetingId: $meetingId, input: $input) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`
export const MANAGER_CONFIRM_PREPARATION = gql`
  mutation ManagerConfirmPreparation($meetingId: HashedId!) {
    managerConfirmPreparation(meetingId: $meetingId) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`
